import styled from 'styled-components';
import { TMHeading, RegText, SmText, XsText, Bold } from './styles';

export const H1 = styled.h1`
    ${TMHeading};
    font-size: 3rem; // 48px
    line-height: 3.5rem; // 56px
    letter-spacing: -0.0625rem; // -1px
`;
H1.displayName = 'H1';

export const H2 = styled.h2`
    ${TMHeading};
    font-size: 2.5rem; // 40px
    line-height: 3rem; // 48px
    letter-spacing: -0.0625rem; // -1px
`;
H2.displayName = 'H2';

export const H3 = styled.h3`
    ${TMHeading};
    font-size: 2rem; // 32px
    line-height: 2.5rem; // 40px
    letter-spacing: -0.03125rem; // -0.5px
`;
H3.displayName = 'H3';

export const H4 = styled.h4`
    ${TMHeading};
    font-size: 1.5rem; // 24px
    line-height: 2rem; // 32px
    letter-spacing: -0.03125rem; // -0.5px
`;
H4.displayName = 'H4';

export const H5 = styled.h5`
    ${TMHeading};
    font-size: 1.25rem; // 20px
    line-height: 1.75rem; // 28px
    letter-spacing: -0.03125rem; // -0.5px
`;
H5.displayName = 'H5';

export const H6 = styled.h6`
    ${TMHeading};
    font-size: 1rem; // 16px
    line-height: 1.625rem; // 26px
    letter-spacing: -0.03125rem; // -0.5px
`;

export const BodyReg = styled.p`
    ${RegText};
`;
BodyReg.displayName = 'BodyReg';

export const BodyRegBold = styled.p`
    ${RegText};
    ${Bold};
`;
BodyRegBold.displayName = 'BodyRegBold';

export const BodySm = styled.p`
    ${SmText};
`;
BodySm.displayName = 'BodySm';

export const BodySmBold = styled.p`
    ${SmText};
    ${Bold};
`;
BodySmBold.displayName = 'BodySmBold';

export const BodyXs = styled.p`
    ${XsText};
`;
BodyXs.displayName = 'BodyXs';

export const BodyXsBold = styled.p`
    ${XsText};
    ${Bold};
`;
BodyXsBold.displayName = 'BodyXsBold';
